var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"iq-ask-anything-header"},[_c('div',{staticClass:"iq-logo-container"},[_c(_setup.Icon,{attrs:{"name":"iq_extlarge_icon"}})],1),_c('h1',{staticClass:"iq-welcome-text"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }